module.exports = __webpack_public_path__ + "static/media/plusIcon.8de1159e.svg";